import { faCheck, faExclamationTriangle, faHourglassEnd, faHourglassHalf, faInfoCircle, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import { corners, gap, nonCustomisableColours, paddingX, paddingY, typography } from "../../styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import styled from "styled-components";
import { applyOpacity } from "../../styles/utils";
type NotificationProps = React.HTMLAttributes<HTMLDivElement> & {
  className?: string;
  variant: NotificationVariant;
};

/* eslint-disable @typescript-eslint/sort-type-union-intersection-members */
export type NotificationVariant = "success" | "info" | "recurrenceInfo" | "timeInfo" | "warning" | "timeWarning";
/* eslint-enable @typescript-eslint/sort-type-union-intersection-members */

/* eslint-disable sort-keys */
export const notificationColourMap: Record<NotificationVariant, string> = {
  success: nonCustomisableColours.success,
  info: nonCustomisableColours.info,
  recurrenceInfo: nonCustomisableColours.info,
  timeInfo: nonCustomisableColours.info,
  warning: nonCustomisableColours.error,
  timeWarning: nonCustomisableColours.error
};
/* eslint-enable sort-keys */

/* eslint-disable sort-keys */
const iconMap: Record<NotificationVariant, React.ReactNode> = {
  success: <FontAwesomeIcon icon={faCheck} />,
  info: <FontAwesomeIcon icon={faInfoCircle} />,
  recurrenceInfo: <FontAwesomeIcon icon={faSyncAlt} />,
  timeInfo: <FontAwesomeIcon icon={faHourglassHalf} />,
  warning: <FontAwesomeIcon icon={faExclamationTriangle} />,
  timeWarning: <FontAwesomeIcon icon={faHourglassEnd} />
};
/* eslint-enable sort-keys */

const StyledNotification = styled.div<NotificationProps>`
  min-height: 2.5rem;
  width: 100%;
  ${corners.m}

  display: flex;
  align-items: center;

  background: ${({
  variant
}) => applyOpacity(notificationColourMap[variant], 0.05)};
  color: ${({
  variant
}) => notificationColourMap[variant]};
  ${paddingY.s}
  ${paddingX.m}
  ${typography.body}
  ${gap.s}
`;
export function Notification({
  children,
  ...props
}: NotificationProps) {
  return <StyledNotification {...props} data-sentry-element="StyledNotification" data-sentry-component="Notification" data-sentry-source-file="Notification.tsx">
      {iconMap[props.variant]}
      {children}
    </StyledNotification>;
}
export default Notification;